import React from 'react';
import cn from 'classnames';
import { NamedContainer } from '@alfa-bank/site-named-container';
import { getButtonViewByKind } from '@alfa-bank/site-button-v2/get-button-view-by-kind';
import { getButtonColorsByTheme } from '@alfa-bank/site-button-v2/get-button-colors-by-theme';

import type { TDesktop } from '../models/desktop';

export function bannerSubMenu(props: TDesktop) {
    const { Button, Img, styles, subMenu, theme } = props;

    if (!subMenu) return null;

    return (
        <div className={styles.subMenu}>
            {subMenu.map(({ href, iconUrl, kind, text, type, view }) => {
                const viewByKind = view || getButtonViewByKind(kind);
                const finalView = type === 'button' ? viewByKind : 'ghost';

                return (
                    <Button
                        key={text}
                        className={cn(styles.external, styles.subMenuItem)}
                        colors={getButtonColorsByTheme(theme)}
                        href={href}
                        size="xxs"
                        view={finalView}
                    >
                        {iconUrl && (
                            <NamedContainer name="leftAddons">
                                <Img alt="Иконка" height={16} src={iconUrl} width={16} />
                            </NamedContainer>
                        )}
                        {text}
                    </Button>
                );
            })}
        </div>
    );
}
